export default [
  {
    path: '/dashboard',
    name: 'dashboard-index',
    meta: {
      title: 'Dashboard',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/dashboard')
    }
  }
]
